// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__9t+EL","active":"modal_active__nzNPo","modalContent":"modal_modalContent__tnARJ"};